import {AsyncState, AsyncStatus} from '@yandex-taxi/react-integration-api'
import {MapContext} from '@yandex-taxi/react-ymaps'
import {createContext, useContext} from 'react'

export type LoaderContextType = AsyncState<never>

export const LoaderContext = createContext<LoaderContextType>({
  status: AsyncStatus.INITIAL,
})

export const useLoaderContext = () => useContext<LoaderContextType>(LoaderContext)

export const useMapContext = () => useContext(MapContext)
